{
  "tov.communications.email.attachments": "להודעה זו מצורפים קבצים.",
  "tov.communications.email.introduction": "{sender} שלח/ה הודעה חדשה לגבי {occasion}.",
  "tov.communications.email.new_message": "יש לך הודעה חדשה.",
  "tov.communications.email.open_thread": "פתיחת השיחה",
  "tov.communications.email.subject_occasion": "{sender} שלח/ה לך הודעה לגבי {occasion}",
  "tov.communications.email.subject_thread": "{sender} שלח/ה לך הודעה בנושא {thread}"
}
